<template>

  <div v-if="meeting" class="MeetingView" :style="{ 'border-color': meeting.user.color }" >
    <div>
      <!-- Close action -->
      <span class="close"></span>
      <div class="content">
        <!-- Title -->
        <h2 class="MeetingView__title">{{ meeting.title }}</h2>
        <h2 class="MeetingView__title">{{ contact.leader_firstname }} {{ contact.leader_lastname }} {{ meeting.projectname }}</h2>
        <!-- Description -->
        <div class="MeetingView__description">{{ meeting.description }}</div>
        <!-- Formated date -->
        <p>{{ date }}</p>
        <!-- Actions -->
        <div class="MeetingView__actions">
          <a class="update" href="#" @click.prevent="edit" >Modifier</a> /
          <a class="delete" href="#" @click.prevent="remove" >Supprimer</a>
        </div>
      </div>
      <!-- Owner -->
      <div class="MeetingView__owner" :style="{ 'background-color': meeting.user.color }" >
        Planning {{ meeting.user.firstname }} {{ meeting.user.lastname }}
      </div>
    </div>
  </div>

</template>

<script>
// Npm modules
import moment from 'moment'
import toastr from 'src/utils/toastr'

// Vuex
import { meeting, meetingDeleted, contact } from 'src/vuex/getters'
import { deleteMeeting } from 'src/vuex/actions/meetingActions'
import { getContact, getContacts } from 'src/vuex/actions/contactActions'

export default{
  vuex: {
    getters: { meeting, meetingDeleted, contact },
    actions: { deleteMeeting, getContact, getContacts }
  },
  computed: {
    date () {
      if (this.meeting.contact_id === null) {
        this.contact.leader_lastname = ''
        this.contact.leader_firstname = ''
      } else {
        this.getContact(this.meeting.contact_id)
      }
      if (this.meeting.title === null) {
        this.meeting.title = ''
      }
      let day = `Le ${moment(this.meeting.start).format('dddd D MMMM YYYY')} `
      if (!this.meeting.all_day) {
        day = day + `de ${moment(this.meeting.start).format('HH:mm')}
        à ${moment(this.meeting.end).format('HH:mm')}`
      }
      // day = day + ' ' + this.contact.leader_firstname + ' ' + this.contact.leader_lastname
      return day
    }
  },
  watch: {
    'meetingDeleted' (deleted) {
      if (deleted) {
        toastr.success('Événement supprimé')
      }
    }
  },
  methods: {
    remove () {
      // let contactIdTmp = this.meeting.contact_id
      this.deleteMeeting(this.meeting)
      // console.log('Evt supprime ' + this.meeting.contact_id + ' VS ' + contactIdTmp)
      this.$router.go('/contact/planning/' + this.meeting.contact_id)
    },
    edit () {
      this.$router.go({ name: 'editMeeting', params: { meetingId: this.meeting.id } })
    },
    ready () {
      console.log(JSON.stringify(this))
      this.getContacts()
    }
  }
}
</script>

<style lang="scss">
  .MeetingView{
    border       : 3px solid;
    background   : white;
    margin-bottom: 20px;
    .content{
      padding: 5px;
    }
  }
  .MeetingView__title{
    font-size    : 1.4em;
    text-align   : center;
    margin-bottom: 1em;
  }
  .MeetingView__description{
    margin-bottom: 1em;
  }
  .MeetingView__actions{
    margin    : 1em;
    text-align: center;
    .update {
      color: $green
    }
    .delete {
      color: $red
    }
  }
  .MeetingView__owner{
    color     : white;
    padding   : 5px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// MeetingView.vue?7ec03bca